import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('GameStore')
@observer
export default class GameStep1 extends Component {

    render() {
        return (
            <div className="step-1">
                <h1>Your choices and your results</h1>
                <p>
                    Your choices on how to answer the questions will lead you to your result, so keep track of your
                    metrics
                    and make the necessary choices to be the winner. In some occasions, you need to be bold and take
                    risks;
                    in others, you had better ask for help and be more cautious. Winning is part of a plan, not a
                    coincidence!
                    <br/><br/>
                    Are you ready?</p>
            </div>
        )
    }

};


// WEBPACK FOOTER //
// ./src/containers/Game/GameStep1.js